import { BoldSpan, NormalSpan } from '../../../styled-components'

const MarkdownBoldText = ({ text }) => {
  const parts = text.split(/(\*\*.*?\*\*)/g)

  return (
    <>
      {parts.map((part, index) => {
        const isBold = part.startsWith('**') && part.endsWith('**')
        const cleanText = isBold ? part.slice(2, -2) : part

        return isBold ? (
          <BoldSpan key={index}>{cleanText}</BoldSpan>
        ) : (
          <NormalSpan key={index}>{cleanText}</NormalSpan>
        )
      })}
    </>
  )
}

export default MarkdownBoldText
